import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { WarningBarService } from '../../../services/warning-bar.service';
import { AuthService } from '../../../services/auth/auth.service';
import { UserRole } from '../../models/user/user-role.enum';
import { Company } from '../../models/company/company';
import { CompanyService } from '../../../services/company.service';

@Component({
  selector: 'psc-warning-bar',
  standalone: true,
  imports: [CommonModule, MatIconModule, RouterLink, TranslocoModule],
  templateUrl: './warning-bar.component.html'
})
export class WarningBarComponent implements OnInit {

  showWarningBar: boolean = true;
  url: string | undefined;
  queryParams: any;
  textKey: string;

  constructor(
    public warningBarService: WarningBarService,
    public authService: AuthService,
    public companyService: CompanyService,
  ) {
  }

  ngOnInit() {
    this.checkForWarnings();
    this.warningBarService.checkWarningsSubject.subscribe((value) => {
      this.checkForWarnings();
    });
    this.warningBarService.hideWarningBarSubject.subscribe((value) => {
      this.showWarningBar = false;
    });
  }

  hideHeader() {
    this.showWarningBar = false;
  }



  checkForWarnings() {
    this.hideHeader();
    if (this.authService.userHasRoles([UserRole.ROLE_BUSINESS_EXP, UserRole.ROLE_BUSINESS_PLUS_EXP])) {
      /**
       * t(sub_needed)
       */
      this.setWarningBar('sub_needed', '/user/profile', { tab: 'Subscription' });
    }

    if (this.authService.userHasRole(UserRole.ROLE_BUSINESS_PLUS)) {
      this.companyService.getMyCompany().subscribe((company: Company) => {
        if (!(company.country && company.email)) {
          /**
           * t(company_data_needed)
           */
          this.setWarningBar('company_data_needed', '/user/profile', { tab: 'CompanyProfile' });
        }
      });
    }
  }


  private setWarningBar(textKey: string, url?: string, queryParams?: any) {
    this.textKey = textKey;
    this.url = url;
    this.queryParams = queryParams;
    this.showWarningBar = true;
  }

}
